<template>
<div id="popupModal" class="popup-modal" @click="hide()">
    <div class="popup-modal-content" @click.stop="">
        <div class="popup-content">
            <div v-if="isAlert || isConfirm" class="content">
                <img class="popup-img" :src="imgUrl" />
                <span class="popup-type-title">{{ title }}</span>
                <div class="popup-message" v-if="text">{{ text }}</div>
                
                <div v-if="isConfirm && askShowAgain" class="ask_show_again">
                    <input type="checkbox" class="h-auto" name="showAgain" id="showAgain" v-model="dontShowAgain">
                    <label for="showAgain">Do not show me it again</label>
                </div>
            </div>
            <div v-else class="input-content">
                <span class="popup-input-title">{{ title }}</span>
                <span class="popup-input-name">{{ inputName }}</span>
                <input type="text" v-virtual-keyboard v-model="input" />
                <!--ExtendedInput (MultiText)-->
                <div v-if="extendedInputName" style="width: 100%;">
                    <br>
                    <span class="popup-input-name">{{ extendedInputName }}</span>
                    <textarea v-virtual-keyboard type="text" style="min-width: 100%; max-width: 100%; height: 100px;" v-model="extendedInput"></textarea>
                </div>
            </div>
        </div>
        <div class="popup-footer">
            <div class="popup-actions">
                <div :class="['popup-btn', isAlert ? 'popup-btn-primary' : 'popup-btn-secondary']" @click="hide(cancelCallback)">
                    {{ isAlert ? 'Close' : isConfirm ? 'No' : 'Cancel' }}</div>
                <div v-if="!isAlert" class="popup-btn popup-btn-primary" @click="ok()">{{ isConfirm ? 'Yes' : 'Ok'
                    }}
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import warning from '../../images/warning.png';
import confirm from '../../images/confirm.png';
import $ from 'jquery'
export default {
    name: 'MessagePopup',
    data() {
        return {
            title: '',
            text: '',
            isAlert: false,
            isConfirm: false,
            askShowAgain: false,
            dontShowAgain: false,
            input: '',
            inputName: '',
            extendedInput: '',
            extendedInputName: '',
            callback: null,
            cancelCallback: null,
        };
    },
    methods: {
        /*
            { 
                title, 
                text, 
                isConfirm,
                askShowAgain,
                cancelCallback,
                isAlert,
                callback
                input : {
                    inputName,
                    inputValue
                }
            }

        */
        show({
            title,
            text,
            isConfirm,
            askShowAgain,
            cancelCallback,
            isAlert,
            callback,
            input
        }) {
            this.title = title;
            this.text = text;
            this.isAlert = isAlert;
            this.isConfirm = isConfirm;
            this.askShowAgain = askShowAgain;
            this.callback = callback;
            this.cancelCallback = cancelCallback;
            if (input) {
                this.inputName = input.inputName
                this.input = input.inputValue;
            }
            $('#popupModal').css('display', 'flex');
        },
        showExtendedInput({
            title,
            text,
            isConfirm,
            askShowAgain,
            isAlert,
            callback,
            input,
            extendedInput
        }) {
            this.title = title;
            this.text = text;
            this.isAlert = isAlert;
            this.isConfirm = isConfirm;
            this.askShowAgain = askShowAgain;
            this.callback = callback;
            if (input) {
                this.inputName = input.inputName
                this.input = input.inputValue;
            }
            if (extendedInput) {
                this.extendedInputName = extendedInput.inputName
                this.extendedInput = extendedInput.inputValue;
            }
            $('#popupModal').css('display', 'flex');
        },
        hide(callback) {
            $('#popupModal').css('display', 'none');
            this.extendedInputName = '';
            this.input = '';
            
            if (callback) callback({ dontShowAgain: this.dontShowAgain });

            this.cancelCallback = null;
            this.askShowAgain = false;
            this.dontShowAgain = false;
        },
        ok() {
            if (!this.isConfirm && !this.input) { //in case of prompt
                alert('Invalid input.');
                return;
            }
            var callbackParameter = ''
            if (this.isConfirm) {
                callbackParameter = true;
            } else if (this.extendedInputName) {
                if (!this.extendedInput) {
                    alert('Invalid input.');
                    return;
                }
                callbackParameter = [
                    this.input,
                    this.extendedInput
                ]
                this.extendedInputName = '';
            } else {
                callbackParameter = this.input
            }
            
            this.hide();
            this.callback(callbackParameter, this.dontShowAgain);
        },
    },
    computed: {
        imgUrl: function () {
            let result = this.isAlert ? warning : this.isConfirm ? confirm : ""
            return result;
        },
    },
}
</script>

<style>
.popup-header {
    padding: 5px;
    background-color: var(--dark-primary-color);
    color: white;
    display: flex;
    align-items: center;
}

.popup-header div {
    flex-grow: 1;
    padding: 5px;
    font-size: 16px;
}

.popup-content {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 10px;
    align-items: center;
    width: calc(100% - 60px);
}

.popup-content .content {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    row-gap: 15px;
}

.input-content {
    flex-direction: column;
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    width: 100%;
}

.popup-input-title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 15px;

}

.popup-input-name {
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 6px;
    color: #4F4F4F;
}

.input-content input {
    width: 100%;
    width: 100%;
    border-color: #4F4F4F;
}

.popup-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 10px;
}

.popup-modal {
    display: none;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    z-index: 9999;
}

.popup-modal-content {
    position: relative;
    background-color: #fefefe;
    margin: auto;
    width: 400px;
    padding: 20px 0px;
    box-shadow: 0 3px 20px 9px rgb(0 0 0 / 10%), 0 2px 2px 0 rgb(0 0 0 / 10%), 0 1px 30px 0 rgb(0 0 0 / 30%);
    animation-name: animatetoppopup;
    border-radius: 10px;
    animation-duration: 0.5s;
    color: var(--primary-color);
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
}

@keyframes animatetoppopup {
    from {
        top: -50vh;
        opacity: 0;
        position: absolute;
    }

    to {
        top: 0;
        opacity: 1;
        position: relative;
    }
}

.close-btn-popup {
    color: white;
    float: right;
    font-size: 28px;
    font-weight: bold;
    cursor: pointer;
}

.close-btn-popup:hover,
.close-btn-popup:focus {
    color: red;
    text-decoration: none;
}

.popup-img {
    width: 100px;
    height: auto;
}

.popup-type-title {
    font-size: 24px;
    font-weight: 500;
    text-transform: uppercase;
}

.popup-message {
    color: #828282;
    font-size: 16px;
    text-align: center;
}

.popup-actions {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px 30px;
    column-gap: 10px;
}

.popup-btn {
    box-shadow: 0 0px 20px 0px rgb(0 0 0 / 6%);
    cursor: pointer;
    text-align: center;
    padding: 6px;
    font-weight: 600;
    border: 1px solid lightgray;
    border-radius: 6px;
    flex: 1 0 0%;
    font-size: 16px;
    transition: all 0.1s ease-out 50ms;
    letter-spacing: 1px;
    text-transform: uppercase;
}

.popup-btn-primary {
    background-color: var(--primary-color);
    color: white;
}

.popup-btn-primary:hover {
    color: var(--primary-color);
    border-color: var(--primary-color);
    background-color: var(--light-primary-color2);
}

.popup-btn-secondary {
    border-color: #4F4F4F;
    color: #4F4F4F;

}

.popup-btn-secondary:hover {
    color: var(--primary-color);
    border-color: var(--light-primary-color);
    background-color: var(--light-primary-color2);
}

.h-auto {
    height: auto;
}

.ask_show_again {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 5px;
    width: 100%;
    color: #2a2a2a;
    -webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

.ask_show_again > * {
    cursor: pointer;
}
</style>
